module.exports = __webpack_public_path__ + "img/mobileintegrated2.8d1252a4.png";